<div class="card">
	<div class="card-header">
		<h5>Bandeja de Formularios de Declaración de Impuestos</h5>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col form-group">
				<label for="filter" class="form-label">Buscar</label>
				<input type="text" (input)="searching()" placeholder="Ingrese un texto para buscar" [(ngModel)]="filter"
					class="form-control" name="filter" id="filter">
			</div>
			<div class="col form-group">
				<label for="month" class="form-label">Mes</label>
				<select name="month" id="month" (change)="getFormsByMonthYearStatusAndType()" [(ngModel)]="month"
					class="form-select">
					<option [ngValue]="1">Enero</option>
					<option [ngValue]="2">Febrero</option>
					<option [ngValue]="3">Marzo</option>
					<option [ngValue]="4">Abril</option>
					<option [ngValue]="5">Mayo</option>
					<option [ngValue]="6">Junio</option>
					<option [ngValue]="7">Julio</option>
					<option [ngValue]="8">Agosto</option>
					<option [ngValue]="9">Septiembre</option>
					<option [ngValue]="10">Octubre</option>
					<option [ngValue]="11">Noviembre</option>
					<option [ngValue]="12">Diciembre</option>
				</select>
			</div>
			<div class="col form-group">
				<label for="year" class="form-label">Año</label>
				<select name="year" id="year" (change)="getFormsByMonthYearStatusAndType()" [(ngModel)]="year"
					class="form-select">
					<option *ngFor="let y of years" [ngValue]="y">{{y}}</option>
				</select>
			</div>
			<div class="col form-group">
				<label for="size" class="form-label">Elementos por página</label>
				<select name="size" id="size" (change)="getFormsByMonthYearStatusAndType()" [(ngModel)]="size"
					class="form-select">
					<option *ngFor="let s of sizes" [ngValue]="s">{{s}}</option>
				</select>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-8 form-group">
				<label for="type" class="form-label">Tipo</label>
				<select name="type" id="type" (change)="getStatusByType()" [(ngModel)]="type" class="form-select">
					<option [ngValue]="1">IVA Pequeño Contribuyente - SAT-2046</option>
					<option [ngValue]="2">IVA General - SAT-2237</option>
					<option [ngValue]="3">ISR Mensual - SAT-1311</option>
					<option [ngValue]="4">ISR Trimestral Renta Estimada - SAT-1361</option>
					<option [ngValue]="5">ISR Trimestral Sobre Utilidades - SAT-1361</option>
					<option [ngValue]="6">ISR Trimestral - SAT-1608</option>
				</select>
			</div>
			<div class="col-sm-4 form-group">
				<label for="status" class="form-label">Estado</label>
				<select name="status" id="status" (change)="getFormsByMonthYearStatusAndType()" [(ngModel)]="status"
					class="form-select">
					<option *ngIf="listStatus.length == 0" [ngValue]="undefined">No se pudieron obtener</option>
					<option *ngFor="let s of listStatus" [ngValue]="s.value">{{s.name}}</option>
				</select>
			</div>
		</div>
		<!-- 
			companyNit
			companyName
			creationDate
			year
			expirationDate
			totalToPay
			monthEnd
			monthStart
		-->
		<div class="table-responsive mt-1">
			<table class="table table-bordered">
				<thead>
					<tr class="tr-middle">
						<th colspan="2" style="background-color: var(--bs-bg-servicios);">
							<h5 style="color:white;">Listado de formularios generados en rango de fechas seleccionado
							</h5>
							<!-- <span class="clickeable text-info" *ngIf="filterForms.length >0"><i
									class="fa fa-hammer"></i>TRABAJAR</span> -->
						</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let form of filterForms">
						<tr [class.tax-form-selected-bottom]="seeing == form.id" class="tax-form"
							(click)="pdf=null; getDetail(form)">
							<td [class.tax-form-selected-bottom]="seeing == form.id" colspan="2"
								class="td-data-company">
								<div class="row">
									<div class="col-sm-10">
										<p class="title-company"><i class="fa fa-building"></i>{{form.companyName}}</p>
										<div class="row">
											<div class="col-sm-8">
												<div class="row">
													<div class="col">
														<b>{{form.companyNit}}</b>
														<br>
														<span class="text-muted">NIT</span>
													</div>
													<div class="col">
														<b>
															{{form.creationDate | date: 'dd/MM/YYYY'}}
														</b>
														<br>
														<span class="text-muted">Creación</span>
													</div>
													<div class="col">
														<b>
															<ng-container *ngIf="form.expirationDate">
																{{form.expirationDate | date: 'dd/MM/YYYY'}}
															</ng-container>
															<ng-container *ngIf="!form.expirationDate">
																-----
															</ng-container>
														</b>
														<br>
														<span class="text-muted">Vencimiento</span>
													</div>
													<div class="col">
														<b>{{form.year}}</b>
														<br>
														<span class="text-muted">Año</span>
													</div>
												</div>
											</div>
											<div class="col-sm-4">
												<b>{{months[form.monthStart]}} - {{months[form.monthEnd]}}</b>
												<br>
												<span class="text-muted">Intervalo de meses</span>
											</div>
										</div>
									</div>
									<div class="col-sm-2">
										<h3 class="text-center">{{form.totalToPay | currency: 'Q'}}</h3>
										<p class="text-muted text-center" style="margin-bottom: 0;">Total</p>
									</div>
								</div>
							</td>
						</tr>
						<tr [class.tax-form-selected-top]="seeing == form.id" *ngIf="seeing == form.id">
							<td [class.tax-form-selected-top]="seeing == form.id"
								[class.tax-form-selected-right]="seeing == form.id">
								<div class="card">
									<div class="card-header">
										<h2>Datos <i (click)="showTopProvider(form)"
												class="fa fa-ranking-star text-info clickeable"
												tooltip="Top de Proveedores"></i></h2>
									</div>
									<div class="card-body">
										<h3 class="title-form">Generales</h3>
										<div>
											<h5 style="text-align: center; font-weight: 700;">{{form.companyName}}</h5>
											<p class="text-muted text-center">Contribuyente/Empresa</p>
										</div>
										<div class="row">
											<div class="col">
												<p class="form-value">{{form.companyNit}}</p>
												<p class="text-muted text-center">NIT</p>
											</div>
											<div class="col">
												<p class="form-value">{{months[form.monthStart]}}</p>
												<p class="text-muted text-center">Mes</p>
											</div>
											<div class="col">
												<p class="form-value">{{form.year}}</p>
												<p class="text-muted text-center">Año</p>
											</div>
										</div>
										<div>
											<p class="form-value">{{form.companyMail?form.companyMail:'No disponible'}}
											</p>
											<p class="text-muted text-center">Correo</p>
										</div>
										<hr>
										<app-tax-form-one *ngIf="form.type === 1" [form]="form"></app-tax-form-one>
										<app-tax-form-two *ngIf="form.type === 2" [form]="form"></app-tax-form-two>
										<app-tax-form-three *ngIf="form.type === 3" [form]="form"></app-tax-form-three>
										<app-tax-form-four *ngIf="form.type === 4" [form]="form"></app-tax-form-four>
										<app-tax-form-five *ngIf="form.type === 5" [form]="form"></app-tax-form-five>
										<div class="row" style="padding-left: 1em; padding-right: 1em;">
											<div class="col">
												Número de Formulario:
											</div>
											<div class="col">
												<p class="text-info text-copy" (click)="copy(form.formNumber)"
													*ngIf="form.status !== 10" style="text-align:right;">
													{{form.formNumber}}
													<i class="fa fa-copy" tooltip="Copiar al portapapeles"
														style="display: none;"></i>
												</p>
												<input type="number" [(ngModel)]="form.formNumber"
													*ngIf="form.status === 10" placeholder="Número de formulario"
													class="form-control">
											</div>
										</div>
										<div class="row" style="padding-left: 1em; padding-right: 1em;">
											<div class="col">
												Código de Acceso:
											</div>
											<div class="col">
												<p class="text-info text-copy" (click)="copy(form.formAccess)"
													*ngIf="form.status !== 10" style="text-align:right;">
													{{form.formAccess}}
													<i class="fa fa-copy" tooltip="Copiar al portapapeles"
														style="display: none;"></i>
												</p>
												<input type="number" [(ngModel)]="form.formAccess"
													*ngIf="form.status === 10" placeholder="Acceso de formulario"
													class="form-control">
											</div>
										</div>
										<div class="row" style="padding-left: 1em; padding-right: 1em;">
											<div class="col">
												Fecha de Expiración:
											</div>
											<div class="col">
												<p class="text-info text-copy" (click)="copy(form.expirationDateAux)"
													*ngIf="form.status !== 10" style="text-align:right;">
													{{form.expirationDate | date: 'dd/MM/YYYY'}}
													<i class="fa fa-copy" tooltip="Copiar al portapapeles"
														style="display: none;"></i>
												</p>
												<input type="date" [(ngModel)]="form.expirationDateAux"
													*ngIf="form.status === 10" class="form-control">
											</div>
										</div>
										<ng-container
											*ngIf="form.type === 2 || form.type === 3 || form.type === 4 || form.type === 5">
											<div class="row" style="padding-left: 1em; padding-right: 1em;"
												*ngIf="form.status !== 10">
												<div class="col">
													Retenciones:
												</div>
												<div class="col">
													<p class="text-info text-copy" (click)="copy(form.withholdings)"
														style="text-align:right;">
														{{form.withholdings | currency: 'Q'}}
														<i class="fa fa-copy" tooltip="Copiar al portapapeles"
															style="display: none;"></i>
													</p>
												</div>
											</div>
										</ng-container>
										<div class="row" style="padding-left: 1em; padding-right: 1em;">
											<div class="col">
												Accesorios:
											</div>
											<div class="col">
												<p class="text-info text-copy" (click)="copy(form.accessories)"
													*ngIf="form.status !== 10" style="text-align:right;">
													{{form.accessories | currency: 'Q. '}}
													<i class="fa fa-copy" tooltip="Copiar al portapapeles"
														style="display: none;"></i>
												</p>
												<input type="number" [(ngModel)]="form.accessories"
													*ngIf="form.status === 10" class="form-control">
											</div>
										</div>
										<div class="row" style="padding-left: 1em; padding-right: 1em;">
											<div class="col">
												<ng-container
													*ngIf="form.type===1 || form.type === 3 || form.type === 4 || form.type === 5">
													*Impuestos a Pagar
												</ng-container>
												<ng-container *ngIf="form.type===2">
													IMPUESTO TOTAL DETERMINADO
													<br>
													<span style="font-size: 0.6em;">(Débitos mayor que Créditos)
														Operaciones de exportación y/o transferencia</span>
												</ng-container>
											</div>
											<div class="col">
												<p class="text-info text-copy" (click)="copy(form.taxesToPay)"
													*ngIf="form.status !== 10" style="text-align:right;">
													{{form.taxesToPay | currency: 'Q. '}}
													<i class="fa fa-copy" tooltip="Copiar al portapapeles"
														style="display: none;"></i>
												</p>
												<input type="number" [(ngModel)]="form.taxesToPay"
													*ngIf="form.status === 10" class="form-control">
											</div>
										</div>
										<div class="row" style="padding-left: 1em; padding-right: 1em;">
											<div class="col">
												Total a Pagar:
											</div>
											<div class="col">
												<p class="text-info text-copy" (click)="copy(form.totalToPay)"
													style="text-align:right;">
													{{form.totalToPay | currency: 'Q'}}
													<i class="fa fa-copy" tooltip="Copiar al portapapeles"
														style="display: none;"></i>
												</p>
											</div>
										</div>
										<div class="row" style="padding-left: 1em; padding-right: 1em;">
											<div class="col">
												Descripción:
											</div>
											<div class="col">
												<textarea name="description" class="form-control" id="description"
													[(ngModel)]="form.description"></textarea>
											</div>
										</div>
										<div class="row" style="padding: 1em; ">
											<div class="input-group" *ngIf="form.status == 20 || form.status == 30">
												<label for="file" class="input-group-text">Archivo</label>
												<input type="file" (change)="onFileChange($event)" accept=".pdf"
													name="file" id="file" class="form-control">
											</div>
										</div>
										<app-loading-button [disabled]="!form.formNumber || !form.formAccess 
										|| (pdf === null && form.status === 20) || (form.expirationDateAux === null && form.status === 10)"
											*ngIf="form.status == 10 || form.status == 20 || form.status == 21 || form.status == 30"
											[changingMessage]="{new: getNextOkayStep(form)}" [object]="buttonOkayStep"
											(clicked)="workOneForm(form)"></app-loading-button>
										<app-loading-button *ngIf="form.status == 20 || form.status == 30"
											[changingMessage]="{new: getNextErrorStep(form)}" [object]="buttonErrorStep"
											(clicked)="workOneForm(form, false)"></app-loading-button>
									</div>
								</div>
							</td>
							<td [class.tax-form-selected-top]="seeing == form.id"
								[class.tax-form-selected-left]="seeing == form.id">
								<div class="card">
									<div class="card-header">
										<h2>Historial</h2>
									</div>
									<div class="card-body">
										<div *ngFor="let h of form.history; let j = index">
											<div style="padding-left: 1em;">
												<span>
													<i class="fa fa-user text-info"></i>
													{{h.userName}}
												</span>
												<br>
												<span>
													<i class="fa fa-envelope text-info"></i>
													{{h.userMail}}
												</span>
												<br>
												<span><i class="fa fa-calendar text-info"></i> {{h.creationDate | date:
													'dd/MM/YYYY'}}</span>
												<br>
												<span><i class="fa fa-clock text-info"></i> {{h.creationDate |
													date:
													'HH:mm:ss'}} hrs</span>
												<br>
												<span style="
													display:block;
													padding-top: 1em;
    												width:200px;
    												word-wrap:break-word;
												"><b>Descripción:</b> {{h.description}}</span>
											</div>
											<div style="position: relative;">
												<hr [ngClass]="j == (form.history.length - 1)?'time-line-end':'time-line-continue'"
													class="time-line">

											</div>
										</div>
									</div>
								</div>
							</td>
						</tr>
					</ng-container>
					<tr class="tr-middle" *ngIf="filterForms.length == 0 && filter && listForms.length > 0">
						<td>
							<span class="display-5 text-muted">
								<i class="fa fa-circle-info"></i>No se encontraron resultados para <span
									style="font-weight: 800 !important; color: var(--bs-bg-servicios);">{{filter}}</span>
							</span>
							<br>
							<span class="text-muted">{{listForms.length}} registros analizados</span>
						</td>
					</tr>
					<tr class="tr-middle" *ngIf="listForms.length == 0 && got">
						<td>
							<span class="display-5 text-muted">
								<i class="fa fa-circle-info"></i>No se cuenta con resultados
							</span>
						</td>
					</tr>
					<tr class="tr-middle" *ngIf="!got">
						<td style="padding: 2em;">
							<div class="d-flex align-items-center">
								<strong role="status">Cargando...</strong>
								<div class="spinner-border ms-auto" aria-hidden="true"></div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
<app-top-provider-list *ngIf="searchTopProvider" [search]="searchTopProvider"
	(close)="searchTopProvider = null"></app-top-provider-list>